// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter--isVne","labelSection":"labelSection--CSbjG","label":"label--gs75Q","description":"description--XzwOd","warning":"warning--g4qbe","info":"info--UNVo9"};